import { useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Map as MapIcon } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const CATEGORY_COLORS = {
  bars: "#2563EB",
  karaoke: "#9333EA",
  restaurants: "#F97316",
  soirees: "#EC4899",
  activites: "#14B8A6",
  hebergements: "#6366F1",
};

const pinIcon = (color) =>
  L.divIcon({
    className: "gospot-pin",
    html: `<div style="width:20px;height:20px;border-radius:9999px;background:${color};border:3px solid #ffffff;box-shadow:0 2px 8px rgba(15,23,42,0.35)"></div>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  });

export const MapPreview = ({ markers = [], showButton = true, className = "" }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  return (
    <div
      data-testid="map-preview"
      className={`relative h-full min-h-[320px] overflow-hidden rounded-3xl border border-slate-100 shadow-[0_4px_20px_rgba(15,23,42,0.06)] ${className}`}
    >
      <MapContainer
        center={[46.8139, -71.208]}
        zoom={13}
        scrollWheelZoom={false}
        zoomControl={false}
        attributionControl={false}
        className="absolute inset-0 h-full w-full"
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {markers.map((m) => (
          <Marker key={m.slug} position={[m.lat, m.lng]} icon={pinIcon(m.color || CATEGORY_COLORS[m.category_key] || "#2563EB")}>
            <Popup>
              <span className="text-sm font-semibold">{m.name || m.title}</span>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
      {showButton && (
        <button
          type="button"
          data-testid="view-map-button"
          onClick={() => navigate("/explorer?vue=carte")}
          className="absolute bottom-4 left-1/2 z-[500] flex -translate-x-1/2 items-center gap-2 whitespace-nowrap rounded-full border border-slate-100 bg-white px-5 py-2.5 text-sm font-semibold text-slate-900 shadow-lg transition hover:-translate-y-0.5 hover:border-blue-200"
        >
          <MapIcon className="h-4 w-4 text-[#2563EB]" />
          {t("Voir la carte")}
        </button>
      )}
    </div>
  );
};
